<!-- 道远足迹 -->
<template>
  <a-modal
    v-model='isShowCard'
    width='800px'
    :keyboard="false"
    :maskClosable="false"
    :destroyOnClose="true"
    :mask="true"
    :closable='false'
  >
    <div slot="title" class="top_bg"   >
      <div style="font-size: 24px;color: #FFFFFF;">{{ $t('usercommissionAgreementCard.year2026PersonalPerformanceTargetNotice') }}</div>
      <div class="cancelIcon" @click="isShowCard = false">
        <pt-icon type="icon-guanbi-hei" style-obj="font-size:18px" :title="$t('baseVO.close')"></pt-icon>
      </div>
    </div>
    <div id="newsPopCard">

      <div class="topDiv">
        <div style="font-size: 16px;color: #323232;margin-bottom: 30px;">{{userCommissionAgreement.userName}}</div>
        <div  v-html="userCommissionAgreement.costAmount"></div>
      </div>
    </div>
    <div slot="footer"  >
      <a-button  type="primary" @click="confirmInfo">
        {{ $t('key14queren') }}
      </a-button>
    </div>
  </a-modal>
</template>

<script lang="jsx">
import moment from 'moment'
import Api from '@/api/manager/userCommissionAgreement'

export default {
  name: 'index',
  data() {
    return {
      isShowCard: true,
      isCheck: false,
      top: 80
    }
  },
  props: {
    userCommissionAgreement: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted() {

  },
  computed: {},
  methods: {

    confirmInfo() {
      let _this = this
      console.log(this.userCommissionAgreement)
      let okText = this.$t('baseVO.confirm')
      let cancelText = this.$t('baseVO.cacel')
      this.$confirm({
        title: '',
        content: '确认信息无误',
        icon: h => <pt-icon type="icon-tishi"></pt-icon>,
        okText: okText,
        cancelText: cancelText,
        okType: 'primary',
        closable: true,
        autoFocusButton: 'ok',
        onOk() {
          Api.confirmInfo(_this.userCommissionAgreement).then(res => {
            if (res.code === 1) {
              _this.$emit('close')
              _this.isShowCard = false
            }
          })
        },
        onCancel() {

        }
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-modal-header{
  padding: 0;
}

.top_bg{
  background-image: url("https://bms2-project.oss-cn-shenzhen.aliyuncs.com/public/2026-bg.png");
  background-size: cover;
  height: 134px;
  text-align: left;
  padding-top: 37px;
  padding-left: 70px;
}

.topDiv{
  margin: 0px 45px 15px;
  font-size: 14px;
  color: #323232;
}

.footerDiv {
  display: flex;
  justify-content: space-between;
  margin: 0px 14%;
  align-items: flex-end;
}

.cancelIcon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>
